import startCase from "lodash-es/startCase";

export function formatShopifyUrl(shopifyUrl: string): string {
  return startCase(shopifyUrl.replace(".myshopify.com", ""));
}
